import Skeleton from 'react-loading-skeleton';
import { useBreakpoint } from '~/hooks';

export default function RelatedListingsLoader() {
  const { mobileScreen } = useBreakpoint();

  return (
    <div className="flex flex-col gap-2x md:gap-3x">
      <div className="flex items-center justify-between">
        <Skeleton width={150} height={24} containerClassName="leading-none" />
        <Skeleton width={80} height={24} containerClassName="leading-none" />
      </div>
      <div className="flex gap-3x">
        {Array(mobileScreen ? 1 : 3)
          .fill(0)
          .map((_, index) => (
            <div
              key={`related-listing-shimmer-${index}`}
              className="flex flex-1 flex-col overflow-hidden rounded-[12px] border border-gray"
            >
              <Skeleton height={192} containerClassName="leading-none" />
              <div className="flex flex-col gap-x p-2x">
                <Skeleton
                  width="60%"
                  height={24}
                  containerClassName="leading-none"
                />
                <Skeleton
                  width="100%"
                  height={20}
                  containerClassName="leading-none"
                />
                <Skeleton
                  width="80%"
                  height={20}
                  containerClassName="leading-none"
                />
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
